import {applyMiddleware, combineReducers, compose, createStore} from "redux";
import thunk from "redux-thunk";
import {autoRehydrate} from "redux-persist";
import rootReducer from "./rootReducer";

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
export default function configureStore(preloadedState) {
    // set middleware
    const middlewares = [thunk];

    const store = createStore(
        combineReducers({
            ...rootReducer,
        }),
        preloadedState,
        composeEnhancers(applyMiddleware(...middlewares), autoRehydrate()),
    );

    if (module.hot) {
        // Enable webpack hot module replacement for reducers
        module.hot.accept("./rootReducer", () => store.replaceReducer(rootReducer));
    }

    return store;
}
